import countries from 'assets/jsons/Country.json';
import statesData from 'app/assets/jsons/State.json';
import { formatMultiSortXGridColumns } from '@AMIEWEB/GlobalSearch/helper';
import { IUserInfo } from 'oidc/user.redux';
import { Authorized } from 'oidc/userHelper';
import { userRoles } from 'oidc/userRoles';

enum ExcludedCountries {
  VIRGIN_ISLANDS = 213,
  PUERTO_RICO = 17,
}

export const getCountryOpts = () => {
  return countries.countries
    .filter(x => x.ID !== ExcludedCountries.PUERTO_RICO && x.ID !== ExcludedCountries.VIRGIN_ISLANDS)
    .map(e => ({
      label: e.Description,
      value: e.CountryDialingCode,
      id: e.ID,
    }));
};

export const getStateOpts = () => {
  return statesData.states.map(e => ({
    id: e.ID,
    label: e.Description,
    value: e.StateNumber,
  }));
};

export const getSortModelPreferences = (sortModel: any[], gridPreferences) => {
  const columnPreferences = gridPreferences?.value;
  if (
    columnPreferences &&
    columnPreferences?.multiSortedColumns &&
    Array.isArray(columnPreferences?.multiSortedColumns)
  ) {
    return formatMultiSortXGridColumns(columnPreferences?.multiSortedColumns);
  }
  return sortModel;
};

export const reasonForLeavingOptions = [
  'Career Advancement',
  'Career Change',
  'Change in Specialty',
  'Currently Working',
  'End of Assignment',
  'Facility Closure / Merger',
  'Per Diem',
  'Personal Reasons',
  'Relocation',
  'To Travel',
];

export const workExperienceColumnVisibility = {
  facilityName: true,
  approvedReferenceCount: false,
  inProgressReferenceCount: false,
  unapprovedReferenceCount: false,
  verifiedReferenceCount: false,
  hasEMPVReference: false,
  placementID: false,
  country: true,
  city: true,
  state: true,
  zip: true,
  disciplineAbbr: true,
  specialtyAbbr: true,
  workHistoryType: true,
  startedOn: true,
  endedOn: true,
  currentlyEmployed: true,
  equipmentProcedures: true,
  reasonForLeaving: true,
  position: true,
  unit: true,
  numberOfBedsInFacility: true,
  travelCompany: false,
  isSupervisor: true,
  isTeletherapy: true,
  isTeachingHospital: true,
};
export const defaultPinnedColumns = {
  left: [],
  right: [],
};

export const userAllowedToEdit = (userInfo: IUserInfo) => {
  return Authorized(
    [
      userRoles.clinical_Director,
      userRoles.clinical_Manager,
      userRoles.clinical_QualificationsSpecialist,
      userRoles.clinical_ReviewAnalyst,
    ],
    userInfo,
  );
};
